import _normalizeInlineWhitespace from "./normalizeInlineWhitespace.js";
import _moveFormattedWord from "./moveFormattedWord.js";
const moveFormattedWord = _moveFormattedWord;
const normalizeInlineWhitespace = _normalizeInlineWhitespace;
const {
  getWords,
  extractFirstWord,
  extractLastWord,
  appendWord,
  prependWord,
  displayLength,
  movedLineLength
} = moveFormattedWord;
export default (function expandText(htmlString, maxCharLimit = 32) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const paragraphs = Array.from(doc.getElementsByTagName("p"));
  if (paragraphs.length <= 1) return htmlString;
  let shortestLength = Infinity;
  let shortestIndex = -1;
  let longestLength = 0;
  paragraphs.forEach((p, index) => {
    const length = displayLength(p);
    longestLength = Math.max(longestLength, length);
    if (length > 0 && length < shortestLength) {
      shortestLength = length;
      shortestIndex = index;
    }
  });
  if (shortestIndex === -1) return htmlString;

  /* An event that is already over the limit can still be expanded as long as no line
     becomes longer than the current longest line. */
  const limit = Math.max(maxCharLimit, longestLength);
  const currentP = paragraphs[shortestIndex];
  const prevP = shortestIndex > 0 ? paragraphs[shortestIndex - 1] : null;
  const nextP = shortestIndex < paragraphs.length - 1 ? paragraphs[shortestIndex + 1] : null;
  const currentWords = getWords(currentP);
  let moved = false;
  if (prevP && currentWords.length > 0) {
    const newPrevLength = movedLineLength(displayLength(prevP), currentWords[0]);
    if (newPrevLength <= limit) {
      const extracted = extractFirstWord(currentP);
      if (extracted) {
        appendWord(prevP, extracted.fragment);
        moved = true;
      }
    }
  }
  if (!moved && nextP && currentWords.length > 0) {
    const lastWord = currentWords[currentWords.length - 1];
    const newNextLength = movedLineLength(displayLength(nextP), lastWord);
    if (newNextLength <= limit) {
      const extracted = extractLastWord(currentP);
      if (extracted) {
        prependWord(nextP, extracted.fragment);
        moved = true;
      }
    }
  }
  if (!moved) return htmlString;
  if (!currentP.textContent.trim()) {
    currentP.remove();
  }
  Array.from(doc.body.getElementsByTagName("p")).forEach(p => normalizeInlineWhitespace(p));
  return doc.body.innerHTML;
});